import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from 'lucide-react';
import { server1 } from "src/utils/httpsRequest";
import { Card, CardContent, CardFooter, CardHeader } from "src/components/ui/card";
import { Label } from "src/components/ui/label";
import { Input } from "src/components/ui/input";
import { Button } from "src/components/ui/button";
import { Checkbox } from "src/components/ui/checkbox";
import { Separator } from "src/components/ui/separator";
import { useNavigate } from 'react-router-dom';
      
import { Link } from "react-router-dom";
export default function Signup() {
  const { org, appid } = useParams(); // Capture org and appid from URL

  // State to manage form input
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [tenantId, setTenantId] = useState("");
    const [orgName, setOrgName] = useState("");
  const [imgName, setImgName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
   const getNestedValue = (obj, path) => {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  };
 const fetchApplicationKeyValue = async (tenantId, appId, keyPath) => {
    const url = `${server1}/api/v2/applications/list_by_id/${tenantId}/${appId}`;
  
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
  
      const data = await response.json();
      const value = getNestedValue(data, keyPath);
  
      if (value !== undefined) {
        return value;
      } else {
        console.warn(`Key path "${keyPath}" not found in response.`);
        return null;
      }
    } catch (error) {
      console.error('Fetch error:', error);
      return null;
    }
  };
  useEffect(() => {
    setTenantId(org || ""); // Dynamically set tenant ID based on org
  }, [org]);
  useEffect(() => {
    setTenantId(org || ""); // Dynamically set tenant ID based on org
    fetchApplicationKeyValue(
      org, appid,
      'full_name'
    ).then(value => {
      console.log('Full Name:', value); // Output: ""
      setOrgName(value)

    });
    fetchApplicationKeyValue(
      org, appid,
      'settings'
    ).then(value => {
      console.log('Full Name:', value.app_logo); // Output: ""
      setImgName(value.app_logo)

    });
  }, [org]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(""); // Clear any previous errors

    const payload = {
      tenant_id: tenantId,
      app_id: appid,
      email,
      password,
      roles: "trainee", // Default role set to "trainee"
    };

    try {
      const response = await fetch(`${server1}/api/v1/users/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      setLoading(false);

      if (response.ok) {
        alert(data.message || "Account created successfully!"); // Display success message
        // window.location.href = `/${org}/${appid}/login`; // Redirect to login page
        navigate(`/${org}/${appid}/login`);
      } else {
        setError(data.detail || "An error occurred. Please try again."); // Use error message from API
      }
    } catch (err) {
      setLoading(false);
      setError("An unknown error occurred. Please try again.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 lg:p-8">
      <div className="mx-auto max-w-4xl">
        <Card className="overflow-hidden">
          <div className="flex flex-col md:flex-row">
            <div className="bg-black p-6 text-white md:w-1/3">
              <div className="mb-8">
                <img
                  src={imgName}
                  alt={orgName}
                  width={150}
                  height={37}
                  className="mb-4"
                />
                <h1 className="text-2xl font-bold">{orgName}</h1>
              </div>
              <p className="mb-4">Join our community of learners and start your journey today!</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Access to premium courses</li>
                <li>Learn from industry experts</li>
                <li>Connect with fellow students</li>
                <li>Earn certificates</li>
              </ul>
            </div>
            <div className="flex-1 p-6">
              <CardHeader>
                <h2 className="text-2xl font-bold text-center">Create Your Account</h2>
              </CardHeader>
              <CardContent>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="space-y-2">
                    <Label htmlFor="email">Email Address *</Label>
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="password">Password *</Label>
                    <Input
                      id="password"
                      name="password"
                      type="password"
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <Separator />
                  <div className="space-y-4">
                    <div className="flex items-center space-x-2">
                      <Checkbox
                        id="terms"
                        required
                      />
                      <label
                        htmlFor="terms"
                        className="text-sm text-gray-500 leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                      >
                        I agree to the <a href="#" className="text-primary underline">terms and conditions</a>
                      </label>
                    </div>
                  </div>
                  {error && <p className="text-red-500">{error}</p>}
                  <Button type="submit" className="w-full" disabled={loading}>
                    {loading ? (
                      <>
                        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                        Please wait
                      </>
                    ) : (
                      'Create Account'
                    )}
                  </Button>
                </form>
              </CardContent>
              <CardFooter className="justify-center">
                <p className="text-sm text-gray-500">
                  Already have an account?{" "}
                  
                  <Link to={`/${org}/${appid}/login`} className="text-primary underline">Sign in</Link>
                </p>
              </CardFooter>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
